import { resourcesService } from "app/services";
import { useQuery } from "@tanstack/react-query";

export function useRepresentacionesGeograficas() {
  const representacionesGeograficas = useQuery({
    queryKey: ["representaciones-geograficas"],
    queryFn: resourcesService.getRepresentacionesGeograficas,
  });

  return representacionesGeograficas;
}
